import React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import Icon from 'components/Icon'
import Tooltip from 'components/Tooltip'
import TxfJobViewModel from './TxfJobViewModel'
import styles from './TxfJobCard.sass'

interface Props {
  vm: TxfJobViewModel
}

export default observer(function TxfJobCard({ vm }: Props) {
  return (
    <div className={cx(styles.root)}>
      <Icon name="txf" size={32} />

      <div className={cx(styles.title)}>Documents have been extracted</div>

      <div className={cx(styles.description)}>
        Review the extracted information and export to supported tax software.
        <Tooltip
          placement="top"
          content={
            'TXF only supports individual (1040) returns via ProConnect and Drake. Business returns may be misclassified as Schedule C.'
          }
        >
          <Icon name="info-blue" size={14} color={'var(--red400)'} />
        </Tooltip>
      </div>

      <button className={cx(styles.button)} onClick={() => vm.viewInTxf()}>
        Review & Export
      </button>
    </div>
  )
})
